import React, { Dispatch, SetStateAction } from "react";
import {
  type BuildData,
  type CompanyData,
  type SessionConfigData,
  type Test,
} from "@/utils/types";
import GptDriverDeviceProvider from "@/components/device-provider/gpt-driver-device-provider";
import type { DeviceContextState } from "@/routes/test-builder-page";
import AppetizeDeviceProvider from "@/components/device-provider/appetize-device-provider";

const DeviceWrapper = ({
  startGptDriverSession,
  companyData,
  sessionConfig,
  deviceContextState,
  test,
  buildData,
  setDeviceContextState,
}: {
  startGptDriverSession: () => void;
  companyData: CompanyData;
  sessionConfig?: SessionConfigData;
  deviceContextState: DeviceContextState;
  test: Test;
  buildData: BuildData;
  setDeviceContextState: Dispatch<SetStateAction<DeviceContextState>>;
}) => {
  if (companyData.settings.enableAppetizeCloneEditor) {
    return (
      <GptDriverDeviceProvider
        startGptDriverSession={startGptDriverSession}
        companyData={companyData}
        deviceContextState={deviceContextState}
        platform={sessionConfig?.platform}
        setDeviceContextState={setDeviceContextState}
      />
    );
  }

  return (
    <AppetizeDeviceProvider
      test={test}
      sessionConfig={sessionConfig}
      buildData={buildData}
      companyData={companyData}
      deviceContextState={deviceContextState}
      setDeviceContextState={setDeviceContextState}
    />
  );
};

export default DeviceWrapper;
